'use client';

import { useTranslation } from 'react-i18next';

import { CopySuccess } from '@/components/ui/Toast/CopySuccess/CopySuccess';
import { useToast } from '@/components/ui/Toast/hook';

export const useCopyUrl = (url?: string) => {
  const { t } = useTranslation();
  const { toast, openToast } = useToast(
    <CopySuccess message={t('Alert.link_copied_message')} />,
    111
  );

  const onCopy = () => {
    const computedLink = url ?? window.location.href;

    navigator.clipboard.writeText(computedLink).then(() => openToast());
  };

  return { toast, onCopy };
};
